import { IOnInit } from "angular";
import {
  IQuery,
  ServiceResponse,
} from "../../../../../../../../../records/server/query";
import { Record } from "../../../../../../../../../records/server/crud";
import { MachineConfigurationView } from "../../../../../../../models/machineConfiguration";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../../../../records/server/serverUtility";

export class GamingContractDetailMachineEditComponentController
  implements IOnInit
{
  static $inject = [ServerUtilityName];
  constructor(private readonly serverUtility: ServerUtility) {}

  currentContractMachinesOnly: boolean = true;
  defaultQuery: IQuery = {};
  contract!: Record;
  selectedIds!: number[];

  $onInit(): void {
    this.defaultQuery.ContractInstanceId = this.contract.ContractInstanceId;
    this.defaultQuery.Ids = this.selectedIds;
  }

  currentContractMachinesOnlyChanged(currentContractMachinesOnly: boolean) {
    this.defaultQuery.Ids = currentContractMachinesOnly
      ? this.selectedIds
      : undefined;
  }

  gridSelectionChanged(
    data: MachineConfigurationView,
    selected: boolean,
    gridSelection: number[]
  ) {
    const url = "/api/contract/machines";
    const contractId = this.contract.Id;

    this.selectedIds = gridSelection;

    selected
      ? this.serverUtility.post({
          url,
          postObject: {
            GamingContractId: contractId,
            MachineId: data.MachineId,
          },
        })
      : this.serverUtility.sendApiRequest<ServiceResponse<Record>>({
          url: url + `/${contractId}/byMachineId`,
          method: "delete",
          data: {
            MachineId: data.MachineId,
          },
        });
  }
}
